export default "<!-- Ngx loader -->\r\n<ngx-ui-loader></ngx-ui-loader>\r\n\r\n<!-- Main view/routes wrapper-->\r\n<router-outlet></router-outlet>"